module.exports = __webpack_public_path__ + "img/impressive_jewelry.fc71536.webp";